import { IAIUsage } from '@/common/interface';
import api from './api';

class AIUsageService {
    async getMyUsage(): Promise<IAIUsage> {
        const response = await api.get('/ai-usage/me/');
        return response.data;
    }
}

export default new AIUsageService();
